import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { redirectToExternalUrl } from 'helpers/RouteHelper';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { PROMO_TYPE_FEATURED_TEXT, getPromoData } from '../../SeriesDetailHelpers';
import style from './StartFreeTrial.css';

const StartFreeTrial = ({ promos = [] }) => {
  const promoData = getPromoData({ data: promos, promoType: PROMO_TYPE_FEATURED_TEXT });
  const content = _.get(promoData, 'items.member[0]', {});
  const buttonText = content.ctaText;
  const { url } = content;
  return (
    <div className={style.container}>
      <h2 className={style.startWatching}>
        {content.headline} <br />
        {content.alternativeHeadline}
      </h2>
      <button
        onClick={() => {
          handleAnalytics({
            event: Events.PURCHASE_CTA_CLICKED,
            payload: {
              page_item_title: content.headline,
              page_item_subtitle: content.alternativeHeadline,
              page_action_location: 'uspell',
              page_button_text: buttonText,
            },
          });
          redirectToExternalUrl(url);
        }}
        className={style.button}
        data-test="upsell-cta"
      >
        {buttonText}
      </button>
    </div>
  );
};

StartFreeTrial.propTypes = {
  promos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default StartFreeTrial;
